import { useCompleteTask, useDeleteTask } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, Trash2 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { InteractionType } from 'shared/types/data-type';
import { Task } from 'shared/types/task';

export type ActionTaskContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'interactionType' | 'onOutside'
> & {
  task: Task;
  onClose: () => void;
};

export const ActionTaskContextMenu: React.FC<ActionTaskContextMenuProps> = ({
  task,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation();

  const completeTask = useCompleteTask();
  const { submit: deleteTask } = useDeleteTask();

  const _completeTask = () => {
    completeTask(task);
    onClose();
  };
  const _deleteTask = () => {
    deleteTask(task);
    onClose();
  };

  return (
    <PopupMenu
      {...rest}
      interactionType={InteractionType.Task}
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuButton
            start={<Icon icon={CheckCircle} />}
            onClick={_completeTask}
          >
            {t(
              task.completedAt
                ? 'context-menus.calendar-events.labels.goal.un-complete.label'
                : 'context-menus.calendar-events.labels.goal.complete.label',
            )}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton start={<Icon icon={Trash2} />} onClick={_deleteTask}>
            {t('context-menus.calendar-events.labels.goal.delete.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
